// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__32oSE","head":"Table_head__3cQGR","col":"Table_col__3o3k7"};